<template>
    <component
        :is="nodeTag"
        v-bind="displayIFramePlaceholder || displayText ? {} : attributes">
        <IFramePlaceholder
            v-if="displayIFramePlaceholder"
            :iframe-info="iframeInfo"
            @activate-external-content="$emit('activateExternalContent')" />
        <SecureHtmlElement
            v-for="childNode in node.childNodes"
            v-else-if="displayElement"
            :key="childNode.uid"
            :node="childNode"
            :show-external-content="showExternalContent"
            @activate-external-content="$emit('activateExternalContent')" />
        <template v-else>
            {{ node.textContent }}
        </template>
    </component>
</template>

<script>
export default {
    name: "SecureHtmlElement",
    props: {
        node: {
            required: true
        },
        showExternalContent: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    computed: {
        nodeTag() {
            if (this.displayIFramePlaceholder) {
                return 'div'
            } else if (this.displayElement) {
                return this.node.tagName
            } else {
                return 'span'
            }
        },
        displayIFramePlaceholder() {
            return this.node.nodeType === 1 && this.node.tagName === 'IFRAME' && !this.showExternalContent
        },
        displayElement() {
            return this.node.nodeType === 1
        },
        displayText() {
            return this.node.nodeType === 3
        },
        iframeInfo() {
            if (!this.displayIFramePlaceholder) return ""
            if (!this.node.hasAttribute('src')) return ""
            return this.node.getAttribute('src')
        },
        attributes() {
            let attr = {}
            if (this.node.nodeType !== 1) return attr
            for (const att of this.node.attributes) {
                if (/^[a-zA-Z0-9\-]+$/.test(att.name))
                    attr = {...attr, [att.name]: att.value}
            }
            return attr
        },
    },
}
</script>

<style scoped>

</style>
